export default {
    fleetSize: null,
    businessUnit: [],
    inquiryModalSubmitted: false,
}

